import axios from "axios";

export const SERVER_URL = process.env.REACT_APP_SERVER_URL ;
export const BOT_URL = process.env.REACT_APP_BOT_URL;
export const PORTAL_API_URL = process.env.REACT_APP_PORTAL_API_URL;
export const NEW_API_URL = process.env.REACT_APP_NEW_API_URL 
export const GG_API = process.env.REACT_APP_GG_API ;
export const ReCAPTCHA_API = process.env.REACT_APP_RECAPTCHA_API;
export const kitsoLogo = process.env.REACT_APP_KITSO_LOGO_URL;

// export default axios.create({
//   baseURL: PORTAL_API_URL,
//   headers: {
//     Accept: "application/json",
//   },
// });

export const newApi = axios.create({
  baseURL: NEW_API_URL,
  headers: {
    Accept: "application/json",
  },
});

// Add response interceptor to save sessionid to localStorage
newApi.interceptors.response.use(
  (response) => {
    // Check if sessionid exists in response data
    const sessionid = response?.data?.data?.session_id;
    if (sessionid) {
      localStorage.setItem('sessionid', sessionid);
    }
    return response;
  },
  (error) => {
    // Handle errors and still check for sessionid in error response
    const sessionid = error?.response?.data?.session_id;
    if (sessionid) {
      localStorage.setItem('sessionid', sessionid);
    }
    return Promise.reject(error);
  }
);

const defaultApi = axios.create({
  baseURL: PORTAL_API_URL,
  headers: {
    Accept: "application/json",
  },
});
export default defaultApi;
